// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import meeting from './modules/meeting'
import transcription from './modules/transcription'
import summary from './modules/summary'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    meeting,
    transcription,
    summary
   
  },
  
  // 全局状态
  state: {
    isLoading: false,
    error: null
  },
  
  mutations: {
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  
  actions: {
    clearError({ commit }) {
      commit('SET_ERROR', null)
    }
  }
})